<template>
  <Slide
    v-if="!isMobile"
    :right="true"
    :disableOutsideClick="isMobile ? false : true"
    :isOpen="slideIsOpen ? true : false"
    :burgerIcon="false"
    :disableEsc="true"
    @openMenu="$emit('openSlider')"
    @closeMenu="$emit('closeSlider')"
  >
    <app-header />
    <!-- <div class="slider-search-panel">
     

      <v-text-field
        class="showSliderInput v-input--is-focused"
        placeholder="جستجو..."
        v-model="searchInput"
        hide-details
        dense
        outlined
      ></v-text-field>
    </div> -->
    <div v-if="hasToken" class="menuOptions">
      <app-options
        v-for="index in filteredMenu.length"
        :key="index"
        :index="index - 1"
        :option="filteredMenu[index - 1]"
        :showHeader="searchInput.trim() == ''"
        @closeSlider="$emit('closeSlider')"
      />
    </div>
  </Slide>
</template>

<script>
import Vue from "vue";
import { getToken } from "@/utils/auth";
import SliderHeader from "./Header";
import SliderOptions from "./Options";
import { Slide } from "vue-burger-menu";
import { toArabicCharacter } from "@/utils/constants";
export default {
  props: ["hasToken", "slideIsOpen", "isMobile"],
  components: {
    Slide,
    appHeader: SliderHeader,
    appOptions: SliderOptions,
  },
  data() {
    return {
      searchArea: false,
      searchInput: "",
    };
  },
  computed: {
    icon() {
      return this.searchArea ? "times" : "search";
    },
    userActive() {
      return this.$store.getters.userInfo.Active;
    },
    menuOptions() {
      return this.$store.getters.menuOptions;
    },
    filteredMenu() {
      return this.menuOptions.filter((single) => {
        return single.title.toLowerCase().includes(this.searchInput);
      });
    },
  },
};
</script>
<style>
.bm-menu {
  background-color: #003470 !important;
  padding-top: 0px !important;
  z-index: 100 !important;
}
.bm-menu::-webkit-scrollbar {
  width: 5px;
  background: white;
}
.bm-menu::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

.bm-menu::-webkit-scrollbar-thumb {
  background: gray;
}

.bm-menu::-webkit-scrollbar-thumb:hover {
  background: gray;
}
.bm-item-list {
  width: 100% !important;
  white-space: nowrap !important;
}

.cross-style {
  display: none;
}

.bm-burger-button {
  position: fixed !important;
  z-index: 2 !important;
  height: 20px !important;
  top: 20px !important;
  width: 30px !important;
}
.bm-burger-bars {
  background-color: white !important;
}
.menuOptions {
  display: block !important;
  padding: 0px !important;
  cursor: pointer;
}

/* .fa-search,
.fa-times {
  color: darkslategray;
  margin-top: 10px;

  float: left;
  cursor: pointer;
} */

.fa-search {
  margin-right: 1px;
}

.fa-times {
  margin-right: 3px;
}

.v-input {
  transition: 0.25s ease-out;
  width: 0;
  transition-property: width;
  color: white !important;
  margin: 0 15px 0 5px;
}
.slider-search-panel {
  height: 60px;
  position: sticky;
  top: 165px;
  z-index: 1;
  background-color: #003470;
}
.slider-search-panel > .v-text-field {
  margin-top: 0;
}
.v-text-field--outlined.v-input--is-focused-alt fieldset {
  border: 1px solid white !important;
}

.showSliderInput input {
  color: white !important;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: lightgray !important;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: lightgray !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: lightgray !important;
}
</style>

